import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Link from 'next/link'
import axios from 'axios'
import styled from 'styled-components'
import constants from '../../../constants/constants'
import styles from '../../../constants/styles'
import * as actions from '../../../actions'
import Auth from '../../../lib/Auth'

import { ButtonLoadingCircularProgress } from '../icons/CircularProgress'

class Login extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      password: '',
      hidePassword: true,
      accessToken: '',
      loading: false,
      errors: {
        email: '',
        password: ''
      },
      focus: {
        email: false,
        password: false
      }
    }
    this.containerRef = null
    this.handleClick = this.handleClick.bind(this)
    this.toggleShowPassword = this.toggleShowPassword.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.checkedForErrors = this.checkedForErrors.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleLogin = this.handleLogin.bind(this)
  }

  handleClick(nextStep) {
    const { setNextStep } = this.props
    setNextStep(nextStep)
  }

  toggleShowPassword() {
    const { hidePassword } = this.state
    this.setState({ hidePassword: !hidePassword })
  }

  handleChange(category, value) {
    // TODO fix
    // eslint-disable-next-line prefer-object-spread
    const obj = Object.assign({}, this.state)
    obj[category] = value
    obj.errors = {
      email: '',
      password: ''
    }
    this.setState(obj)
  }

  checkedForErrors() {
    const { errors, password, accessToken, email } = this.state
    let checked = true
    // TODO fix
    // eslint-disable-next-line prefer-object-spread
    const obj = Object.assign({}, errors)
    if (password.length < 8 && !accessToken) {
      obj.password = 'The password should be at least 8 characters long'
      checked = false
    }
    if (
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      obj.email = 'That email is not formatted correctly'
      checked = false
    }
    if (!email.length) {
      obj.email = 'Please fill in your email'
      checked = false
    }
    this.setState({ errors: obj })
    return checked
  }

  handleSubmit(e) {
    const { email, password } = this.state
    const { updateForm } = this.props
    e.preventDefault()
    updateForm('email', email)
    const user = {
      email,
      password
    }
    if (this.checkedForErrors()) {
      this.handleLogin(user)
    }
  }

  handleLogin(user) {
    const { setNextStep, updateForm } = this.props
    this.setState({ loading: true })
    axios
      .post(constants.api.auth.login, user)
      .then((res) => {
        if (res.data.success) {
          updateForm('token', res.data.token)
          updateForm('username', res.data.user.username)
          axios.defaults.headers.common.Authorization = `bearer ${res.data.token}`
          Auth.initializeWith(res.data)
          setNextStep('form')
        } else {
          this.setState({
            loading: false,
            errors: {
              email: 'Your email and/or your password is not valid',
              password: 'Your email and/or your password is not valid'
            }
          })
        }
      })
      .catch((err) => {
        console.error(err)
        this.setState({
          loading: false,
          errors: {
            email: 'Your email and/or your password is not valid',
            password: 'Your email and/or your password is not valid'
          }
        })
      })
  }

  render() {
    const { hidePassword, password, errors, focus, email, loading } = this.state
    return (
      <Container>
        <SubTitle>Login to your abillion account</SubTitle>
        <Form onSubmit={this.handleSubmit}>
          <Label htmlFor="email">Email</Label>
          <TextContainer error={errors.email} hasFocus={focus.email}>
            <TextInput
              autoFocus
              placeholder="Your email address"
              type="email"
              name="email"
              value={email}
              onChange={(e) =>
                this.handleChange('email', e.target.value.trim().toLowerCase())
              }
            />
          </TextContainer>
          <ErrorDiv>{errors.email}</ErrorDiv>
          <HorizontalContainer>
            <Label htmlFor="password">Password</Label>
            <ShowPassword type="button" onClick={this.toggleShowPassword}>
              {hidePassword ? 'Show password' : 'Hide password'}
            </ShowPassword>
          </HorizontalContainer>

          <TextContainer error={errors.password} hasFocus={focus.password}>
            <Password
              type={hidePassword ? 'password' : 'text'}
              name="password"
              value={password}
              onChange={(e) => this.handleChange('password', e.target.value)}
              placeholder="Minimum 8 characters"
            />
          </TextContainer>
          <ErrorDiv>{errors.password}</ErrorDiv>
          <LoginButton onClick={(e) => this.handleSubmit(e)}>
            {loading ? <ButtonLoadingCircularProgress size={20} /> : 'Log in'}
          </LoginButton>
        </Form>
        <Text>
          Don&apos;t have an account?&nbsp;
          <SignButton onClick={() => this.handleClick('signup')}>
            Sign up
          </SignButton>
        </Text>
        <ForgotPassword>
          <Link href="/forgot">
            <a style={{ color: styles.colors.darkGrey }}>
              Forgot your password?
            </a>
          </Link>
        </ForgotPassword>
      </Container>
    )
  }
}

Login.propTypes = {
  setNextStep: PropTypes.func.isRequired,
  updateForm: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => ({
  updateForm: (category, value) => {
    dispatch({ type: actions.UPDATE_FORM_AMBASSADOR, category, value })
  },
  setNextStep: (step) => {
    dispatch({ type: actions.SET_NEXT_STEP, step })
  }
})

export default connect(null, mapDispatchToProps)(Login)

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${styles.margin.large};
  padding: ${styles.padding.medium};
`

const SubTitle = styled.h2`
  color: ${styles.colors.darkGrey};
  margin: ${styles.margin.small};
  text-align: center;
  font-size: 1.5em;
`

const Text = styled.p`
  color: ${styles.colors.grey};
  width: 100%;
  font-size: 1em;
  text-align: center;
`
const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const Form = styled.form`
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Label = styled.p`
  color: ${styles.colors.darkGrey};
  text-align: left;
  width: 100%;
  font-size: 1em;
  margin: ${styles.margin.tiny};
  padding-left: ${styles.padding.small};
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  background-color: ${styles.colors.white};
  color: ${styles.colors.black};
  padding: 0 ${styles.padding.medium};
  border: 2px solid
    ${(props) => {
      switch (true) {
        case props.error:
          return styles.colors.action
        case props.hasFocus:
          return styles.colors.black
        default:
          return styles.colors.grey
      }
    }};
  border-radius: 50px;
  overflow: hidden;
`

const TextInput = styled.input`
  width: 100%;
  height: 40px;
  resize: none;
  cursor: text;
  white-space: normal;
  font-size: 1em;
  ::-webkit-input-placeholder {
    /* Chrome */
    color: ${styles.colors.salmon};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${styles.colors.salmon};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
`
const ErrorDiv = styled.span`
  color: ${styles.colors.action};
  margin-top: ${styles.margin.small};
  font-size: 0.8em;
`

const Password = styled.input`
  cursor: text;
  font-size: 1em;
  white-space: normal;
  width: 100%;
  height: 40px;
  ::-webkit-input-placeholder {
    /* Chrome */
    color: ${styles.colors.salmon};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${styles.colors.salmon};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
  :-moz-placeholder {
    /* Firefox 4 - 18 */
    color: ${styles.colors.salmon};
    opacity: 1;
  }
`

const LoginButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 400px;
  padding: ${styles.padding.small};
  border: 2px solid ${styles.colors.facebook};
  color: ${styles.colors.white};
  border-radius: 50px;
  font-size: 0.8em;
  margin: ${styles.margin.small};
  cursor: pointer;
  background-color: #7500cb;
  font-weight: 600;
  border: 2px solid #7500cb;
  &:hover {
    background-color: ${styles.colors.white};
    color: #7500cb;
    border: 2px solid #7500cb;
  }
`

const SignButton = styled.button`
  color: #7500cb;
  cursor: pointer;
  font-size: 1em;
`

const ShowPassword = styled.button`
  color: ${styles.colors.facebook};
  font-size: 0.8em;
  width: 100%;
  text-align: right;
  margin-right: ${styles.margin.small};
  cursor: pointer;
`
const ForgotPassword = styled.div`
  width: 100%;
  max-width: 480px;
  padding: ${styles.padding.medium};
  color: ${styles.colors.darkGrey};
  text-align: center;
  border-bottom: 1px solid ${styles.colors.lightGrey};
  font-size: 0.9em;
`
